// extracted by mini-css-extract-plugin
export default {"image-container":"projectImage_image-container__lvS7r","project-image":"projectImage_project-image__+c7s+","project-image-light-mode":"projectImage_project-image-light-mode__8U43r"};